var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecentActions(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5014 4.01134C9.48015 2.75342 6.0321 3.94395 4.41476 6.69566H4.426H5.9984C6.41396 6.69566 6.75091 7.0326 6.75091 7.44817C6.75091 7.86373 6.41396 8.21191 5.9984 8.21191H2.76374C2.34818 8.21191 2 7.87496 2 7.4594V4.22474C2 3.80917 2.33694 3.47223 2.75251 3.47223C3.16807 3.47223 3.51625 3.80917 3.51625 4.22474V5.32542C5.63899 2.37155 9.59247 1.15855 13.0742 2.61864C17.1625 4.32582 19.0831 9.00934 17.3759 13.0864C15.6687 17.1634 10.9852 19.084 6.90815 17.3768C4.49338 16.3659 2.83113 14.3106 2.23586 11.9632C2.13478 11.5589 2.38187 11.1433 2.7862 11.0422C3.19054 10.9412 3.6061 11.1882 3.70718 11.5926C4.19014 13.5019 5.53791 15.1642 7.49219 15.9841C10.7942 17.3655 14.6017 15.8044 15.9832 12.5023C17.3646 9.20028 15.8147 5.39281 12.5014 4.01134ZM9.68182 7.00085C10.0584 7.00085 10.3636 7.30611 10.3636 7.68267V10.516H12.3182C12.6947 10.516 13 10.8213 13 11.1978C13 11.5744 12.6947 11.8796 12.3182 11.8796H9.68182C9.30526 11.8796 9 11.5744 9 11.1978V7.68267C9 7.30611 9.30526 7.00085 9.68182 7.00085Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActions);
export default __webpack_public_path__ + "static/media/recent-actions.350964e8.svg";
export { ForwardRef as ReactComponent };